import { isNullOrEmpty } from "./string";

export enum EnvVar {
  API_GATEWAY_URL = "API_GATEWAY_URL",
  CONTENTFUL_SPACE_ID = "CONTENTFUL_SPACE_ID",
  FLOWMAILER_CLIENT_ID = "FLOWMAILER_CLIENT_ID",
  FLOWMAILER_CLIENT_SECRET = "FLOWMAILER_CLIENT_SECRET",
  FLOWMAILER_APPLICATION_ID = "FLOWMAILER_APPLICATION_ID",
  LOG_LEVEL = "LOG_LEVEL",
  APP_REGISTRATION_CLIENT_ID = "APP_REGISTRATION_CLIENT_ID",
  APP_REGISTRATION_CLIENT_SECRET = "APP_REGISTRATION_CLIENT_SECRET",
  EP_CLIENT_SCOPE = "EP_CLIENT_SCOPE",
  NODE_ENV = "NODE_ENV",
  OPERATIONALINFO_CLIENT_SCOPE = "OPERATIONALINFO_CLIENT_SCOPE",
  CONTENTFUL_PREVIEW_SECRET = "CONTENTFUL_PREVIEW_SECRET",
  APSIS_CRM_CLIENT_ID_SCOPE = "APSIS_CRM_CLIENT_ID_SCOPE",
  AFASE_API_KEY = "AFASE_API_KEY",
  AFASE_API_APP_REGISTRATION_CLIENT_ID = "AFASE_API_APP_REGISTRATION_CLIENT_ID",
  CONTENTFUL_REDIRECT_MANAGER_SECRET = "CONTENTFUL_REDIRECT_MANAGER_SECRET",
  CONTENTFUL_WEBHOOK_SECRET = "CONTENTFUL_WEBHOOK_SECRET",
}

export function envOrUndefined(envVar: EnvVar): string | undefined {
  return process.env[envVar.valueOf()];
}

export function envOrDefault(envVar: EnvVar, defaultValue: string): string {
  return envOrUndefined(envVar) ?? defaultValue;
}

export function envOrError(envVar: EnvVar): string {
  const value = envOrUndefined(envVar);

  if (isNullOrEmpty(value)) {
    throw new Error(`Missing required environment variable ${envVar.valueOf()}`);
  }
  return value;
}

export function isNodeEnvProd(): boolean {
  return envOrUndefined(EnvVar.NODE_ENV) === "production";
}
